module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/226.d3e7a565.png";